import { getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name : 'customCurrency' })
export class CustomCurrencyPipe implements PipeTransform{
    transform(currency: number, currencyCode: string, format: 'wide' | 'narrow' = 'narrow'): string {
        return `${currency} ${getCurrencySymbol(currencyCode, format)}`;
    }
}